export default {
  "content": "<path d=\"M22 6a2 2 0 012 2v11a2 2 0 01-2 2h-7a2 2 0 01-2-2v-3h2v3h7V8h-5V6h5zM10 18H5v-2h5v2z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.204 3.01A2 2 0 0115 5v7a2 2 0 01-2 2H2a2 2 0 01-2-2V5a2 2 0 012-2h11l.204.01zM2 12h11V5H2v7z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};